import React, { Component } from 'react';
import cookie from 'cookie';
import { WithStyles, withStyles } from '@mui/styles';
import * as Yup from 'yup';
import axios from 'axios';
import { Formik, Form } from 'formik';
import { isFirefox } from 'react-device-detect';
import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import APInput from '../../../components/atoms/APInput';
import APButton from '../../../components/atoms/APButton';
import APHeading from '../../../components/atoms/APHeading';
import APLabel from '../../../components/atoms/APLabel';
import APLoadingSpinner from '../../../components/atoms/APLoadingSpinner';
import APResetImagePlaceholder from '../../../components/atoms/APResetImagePlaceholder';
import APErrorMessage from '../../../components/atoms/APErrorMessage';
import { ReactComponent as PasswordChangedIcon } from '../../../components/atoms/APResetImagePlaceholder/assets/PasswordChangedIcon.svg';
import { ReactComponent as Visibility } from '../../../components/atoms/APPasswordInput/assets/VisibilityIcon.svg';
import { ReactComponent as VisibilityOff } from '../../../components/atoms/APPasswordInput/assets/VisibilityOffIcon.svg';
import IconButton from '@mui/material/IconButton';
import CreatePasswordContainerStyles from '../styles/PasswordReset.style';
import { withTranslate, withTenant, withNavigation } from '../../../core/TenantProvider';
import { actions as servicesDowntimeAction } from '../../../redux/modules/servicesDowntime';
import { getBasicAuthToken } from '../../../core/utils/BasicAuthTokenGetter';
import APBackdropLoader from '../../../components/atoms/APBackdropLoader';
import EncodeData from '../../../core/utils/EncodeDecodeData';
import { AxiosDefaultsType } from '../../../core/types/GeneralTypes';
import { getConfigProperty } from '../../../core/EnvironmentConfig/EnvironmentConfig';

const newPasswordEndPoint: any = getConfigProperty('apiEndPoint')['newPassword'];

interface CreatePasswordContainerProps
	extends WithStyles<typeof CreatePasswordContainerStyles> {
	classes: any;
	navigate: any;
	values: any;
	touched: any;
	errors: any;
	dirty: boolean;
	isValid: boolean;
	handleChange: any;
	handleBlur: any;
	handleSubmit: any;
	translate: Function;
	settings: any,
	getServicesErrorObj: Function,
	updateTenant: Function
}

interface CreatePasswordContainerState {
	currentStep: number;
	lastStep: number;
	newPassword: string;
	confirmPassword: string;
	showPassword: boolean;
	showConfirmPassword: boolean;
	loaded: boolean;
	isError: boolean;
	serverError: string;
	confirming: boolean;
	msgHasLink: boolean,
	basicAuthToken: string,
	isLoading: boolean,
	intervalId: number
}

class CreatePasswordContainer extends Component<CreatePasswordContainerProps, CreatePasswordContainerState> {

	constructor(props: CreatePasswordContainerProps) {
		super(props);

		this.state = {
			currentStep: 0,
			lastStep: 2,
			newPassword: "",
			confirmPassword: "",
			showPassword: false,
			showConfirmPassword: false,
			loaded: false,
			isError: false,
			serverError: "",
			confirming: true,
			msgHasLink: false,
			basicAuthToken: '',
			isLoading: true,
			intervalId: -1
		};
	}

	getAxiosDefaults = (accessToken: string) => {
		return {
			"baseURL": "",
			"headers": {
				"Access-Control-Allow-Origin": "*",
				"Authorization": `Basic ${accessToken}`,
				"Content-Type": "application/json"
			}
		}
	}

	componentDidMount() {
		const referringCompany = cookie.parse(document.cookie).cdhCompany;
		let basicAuthToken: string = getBasicAuthToken(referringCompany);

		if (!isFirefox) {
			if (!referringCompany || referringCompany === 'undefined') {
				let intervalId = window.setInterval(() => {
					let referringCdhCompany = cookie.parse(document.cookie).cdhCompany;
					if (referringCdhCompany && (referringCdhCompany !== 'undefined')) {
						const { updateTenant } = this.props;
						basicAuthToken = getBasicAuthToken(referringCdhCompany);
						updateTenant(referringCdhCompany);
						this.setState({
							isLoading: false,
							basicAuthToken,
							intervalId
						});
					}
				}, 2000);
				this.setState({
					isLoading: true
				});
			} else {
				this.setState({
					isLoading: false,
					basicAuthToken
				});
			}
		}

		if (isFirefox && this.state.basicAuthToken.length === 0) {
			this.setState({
				isLoading: false,
				intervalId: -1,
				basicAuthToken
			});
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const referringCompany = cookie.parse(document.cookie).cdhCompany;
		let basicAuthToken: string = getBasicAuthToken(referringCompany);

		if (isFirefox && basicAuthToken !== this.state.basicAuthToken && this.state.basicAuthToken.length === 0) {

			this.setState({
				basicAuthToken
			})
		}
	}

	Step1Schema = Yup.object().shape({
		newPassword: Yup.string()
			.required("Please enter your password")
			.min(10, "Password is too short - should be 10 characters minimum")
			.max(16, "Password is too long - should be 16 characters maximum")
			.matches(
				/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?|<>])(?=.{10,16})/,
				"Password must contain at least one lower, upper, numeric and special character"
			),
		confirmPassword: Yup.string()
			.required("Please confirm your password")
			.oneOf([Yup.ref("newPassword"), null], "Passwords must match"),
	});

	schemaArray = [this.Step1Schema];

	nextStep = (props: any) => {
		props.submitForm().then(() => {
			if (props.isValid) {
				this.setState((state) => ({
					currentStep: Math.min(state.currentStep + 1, state.lastStep),
				}));
				props.validateForm();
				props.setTouched({});
			}
		});
	};

	handleResponseError = (error: { response: { status: number; data: { code: string; }; }; }, translate: Function) => {
		if (error.response.status !== 200) {
			let serverError: string,
				msgHasLink = false;
			switch (error.response.data.code) {
				case '2007':
					serverError = translate('create.password.samepassword.error');//this.state.samePasswordErrorMsg;
					break;

				case '2005':
				case '2006':
					serverError = translate('create.password.reset.password.error');//this.state.linkExpiredErrorMsg;
					msgHasLink = true;
					break;
				default:
					serverError = translate('create.password.generic.error');//this.state.genericErrorMsg;
			}
			this.setState((state) => ({
				loaded: false,
				isError: true,
				serverError,
				msgHasLink,
				currentStep: Math.max(state.currentStep - 1, 0),
			}));
		}
	}

	handleSubmit = (values: any, formikbag: any) => {
		const {
			translate,
			getServicesErrorObj
		} = this.props;
		const searchString: string = document.location.search;

		if (!searchString) {
			console.log('No Query Parameters');
		} else {
			const splitEmailUrlArray: string[] = searchString?.split("="),
				expiryToken: string = splitEmailUrlArray && splitEmailUrlArray.length > 0 ? splitEmailUrlArray[2]?.slice(0, -6) : '',
				emailToken: string = splitEmailUrlArray && splitEmailUrlArray.length > 0 ? splitEmailUrlArray[1]?.slice(0, -3) : '',
				email = splitEmailUrlArray[3];
			setTimeout(() => {
				formikbag.setSubmitting(false);
			}, 1000);

			const axiosDefaults: AxiosDefaultsType = this.getAxiosDefaults(this.state.basicAuthToken);
			axios.defaults.baseURL = axiosDefaults.baseURL;
			axios.defaults.headers.post = axiosDefaults.headers;

			axios
				.post(
					newPasswordEndPoint,
					{
						"organisation": sessionStorage.getItem("organisation"),
						"email": email,
						"password": EncodeData(values.newPassword),
						"email_token": emailToken,
						"expiry_token": expiryToken
					}
				)
				.then((response) => {
					this.setState({
						loaded: true,
						isError: false,
					});
					if (!sessionStorage.getItem("access token")) {
						sessionStorage.setItem("access token", this.state.basicAuthToken);
					}
				})
				.catch((error) => {
					this.handleResponseError(error, translate);
					getServicesErrorObj(error);
				});
		}
	};

	loginPath(path: string) {
		this.props.navigate(path);
	}

	resetPasswordPath(path: string) {
		this.props.navigate(path);
	}

	togglePasswordMask = () => {
		this.setState((prevState) => ({
			showPassword: !prevState.showPassword,
		}));
	};

	toggleConfirmPasswordMask = () => {
		this.setState((prevState) => ({
			showConfirmPassword: !prevState.showConfirmPassword,
		}));
	};

	handleChange(e: React.ChangeEvent<HTMLInputElement>) {
		this.setState({ newPassword: e.target.value });
	}

	step1 = (props: any) => {
		if (this.state.currentStep === 0) {
			const { classes, translate } = this.props;
			return <>
				{this.state.isError ? (<APErrorMessage errorMessage={this.state.serverError} hasLink={this.state.msgHasLink} linkMessage={translate('create.password.reset.password.clickhere')} link='/resetpassword' />) : ("")}
				<div className={classes.resetPasswordIntro}>
					<>
						<APHeading
							className={classes.resetPasswordIntroHeader}
							variant="h4"
						>
							{translate("reset.password.intro.header.step.three")}
						</APHeading>
						<APLabel className={classes.resetPasswordIntroText}>
							{translate("reset.password.intro.text.step.three")}
						</APLabel>
					</>
				</div>
				<>
					<div className={classes.inputsSurround}>
						<IconButton
							aria-label="toggle new password visibility"
							onClick={this.togglePasswordMask}
							edge="end"
							className={classes.passwordEyeIcon}
							size="large">
							{this.state.showPassword ? <Visibility /> : <VisibilityOff />}
						</IconButton>
						<APInput
							autoComplete="off"
							data-testid='passwordInput'
							type={this.state.showPassword ? "text" : "password"}
							label={translate("create.password.new.password.label")}
							name="newPassword"
							className={classes.resetPasswordInput}
							error={props.errors.newPassword && props.touched.newPassword}
							helperText={props.touched.newPassword && props.errors.newPassword}
							value={props.values.newPassword}
							onChange={props.handleChange}
							onBlur={props.handleBlur}
							inputProps={{ tabIndex: "1" }}
							isCoralogixMasked={true}

						/>
					</div>
					<div className={classes.inputsSurround}>
						<IconButton
							aria-label="toggle confirm password visibility"
							onClick={this.toggleConfirmPasswordMask}
							edge="end"
							className={classes.passwordEyeIcon}
							size="large">
							{this.state.showConfirmPassword ? <Visibility /> : <VisibilityOff />}
						</IconButton>
						<APInput
							autoComplete="off"
							data-testid='confirmPasswordInput'
							type={this.state.showConfirmPassword ? "text" : "password"}
							label={translate("create.password.retype.password.label")}
							name="confirmPassword"
							className={classes.resetPasswordInput}
							error={props.errors.confirmPassword && props.touched.confirmPassword}
							helperText={props.touched.confirmPassword && props.errors.confirmPassword}
							value={props.values.confirmPassword}
							onChange={props.handleChange}
							onBlur={props.handleBlur}
							inputProps={{ tabIndex: "2" }}
							isCoralogixMasked={true}
						/>
					</div>
					<div className={classes.createPasswordActions}>
						<APButton
							name="submit"
							data-testid='submit'
							className={classes.resetPasswordButtons}
							type="button"
							variant="contained"
							color="primary"
							disabled={!(props.isValid && props.dirty)}
							onClick={() => {
								this.nextStep(props);
							}}
							tabIndex={3}
							disableRipple={true}
						>
							{translate("reset.password.form.action.submit.password.label")}
						</APButton>
					</div>
				</>
			</>;
		}
	};

	step2 = (props: any) => {
		if (this.state.currentStep === 1) {
			const { classes, navigate, translate } = this.props;
			this.state.loaded && !this.state.isError && setTimeout(() => navigate("/login"), 10000);
			return (
				<>
					{this.state.loaded && !this.state.isError ? (
						<>
							<div className={classes.resetPasswordIntro}>
								<APHeading
									className={classes.resetPasswordIntroHeader}
									variant="h4"
								>
									{translate("reset.password.intro.header.step.four")}
								</APHeading>
								<APLabel className={classes.resetPasswordIntroText}>
									{translate("reset.password.intro.text.step.four")}
								</APLabel>
							</div>
							<div className={classes.inputsSurround}>
								<APResetImagePlaceholder>
									<PasswordChangedIcon />
								</APResetImagePlaceholder>
							</div>
							<div className={classes.resetPasswordActions}>
								<APButton
									data-testid='loginBtn'
									className={classes.loginButton}
									type="button"
									variant="contained"
									color="primary"
									onClick={() => this.loginPath("/login")}
								>
									{translate("login.action.login.label")}
								</APButton>
							</div>
						</>
					) : (
						<div className={classes.resetPasswordLinkSection}>
							<APLoadingSpinner />
						</div>
					)}
				</>
			);
		}
	};

	render() {
		const { currentStep, isLoading, intervalId } = this.state;
		const { schemaArray } = this;
		const { classes, settings } = this.props;
		settings.ORG_CODE && sessionStorage.setItem("organisation", settings.ORG_CODE);

		if (!isLoading && intervalId && settings.ORG_CODE) {
			window.clearInterval(intervalId);
		}

		return (
			(!isFirefox && (isLoading || !settings.ORG_CODE)) ? (
				<APBackdropLoader open={true} />
			) : (
				<div className={classes.resetPasswordContainer}>
					<div className={classes.resetPasswordContent}>
						<Formik onSubmit={this.handleSubmit} enableReinitialize initialValues={{ newPassword: "", confirmPassword: "" }} validationSchema={schemaArray[currentStep]}>
							{(props: any) => (
								<Form>
									{this.step1(props)}
									{this.step2(props)}
								</Form>
							)}
						</Formik>
					</div>
				</div>
			)
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
	getServicesErrorObj: servicesDowntimeAction.getServicesErrorObj
}, dispatch);

export default connect(null, mapDispatchToProps)(
	withNavigation(
		withTenant(withTranslate(
			withStyles(CreatePasswordContainerStyles)(CreatePasswordContainer)
		)
		))
);
